<template>
  <component :is="registerComponent" />
</template>

<script>
import { getRegisterComponent } from '@/util/getFileComponent';

export default {
  computed: {
    registerComponent() {
      return getRegisterComponent(`verificationStatus`, this.regulator);
    }
  }
};
</script>
